const ICON_TYPE = {
  ADD: 'add',
  ADD_CASH: 'addCash',
  CHECK: 'check',
  GOTO: 'goto',
  MESSAGE: 'message',
};

export default ICON_TYPE;
